module.exports = __webpack_public_path__ + "static/media/ceo.b0582e5f.png";